import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { paymentsFetch } from "./paymentsFetch";

const AddBooingPayment = async (body: any) => {
  return paymentsFetch(`/api/payments/manual`, "POST", body);
};

export const useAddBookingPaymentMutation = (bookingId: string) => {
  const queryClient = useQueryClient();
  const { toast, dismiss } = useToast();

  return useMutation({
    mutationFn: (data: { body: any; toastId: any }) => {
      return AddBooingPayment(data.body);
    },
    onSuccess: (_, variables) => {
      dismiss(variables.toastId);

      toast({
        title: "Success",
        description: "Payment added successfully!",
        variant: "default",
      });

      queryClient.invalidateQueries({ queryKey: ["paymentsData", bookingId] });
      queryClient.invalidateQueries({ queryKey: ["paymentScheduleCustomerData", bookingId] });
      queryClient.invalidateQueries({ queryKey: ["paymentScheduleOperatorData", bookingId] });
    },
    onError: (error: any, variables) => {
      dismiss(variables.toastId);
      toast({
        title: "Error",
        description: error.message || "Failed to add booking payment!",
        variant: "destructive",
      });
    },
  });
};
